// extracted by mini-css-extract-plugin
module.exports = {"root":"banned-info-module__root___1XWkn","icon":"banned-info-module__icon___1tER4"};